import {Mapper} from '@s-ui/domain'

export default class FromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper extends Mapper {
  constructor({marketedYearValueObject, availableMarketedYearsValueObject}) {
    super()
    this._marketedYearValueObject = marketedYearValueObject
    this._availableMarketedYearsValueObject = availableMarketedYearsValueObject
  }

  map = ({availableYears, currentYear, path}) => {
    const items = availableYears.map(year => {
      const isSelected = year === currentYear
      return this._marketedYearValueObject({
        title: year,
        url: `${path}?year=${year}`,
        ...(isSelected && {isSelected})
      })
    })
    return this._availableMarketedYearsValueObject({items})
  }
}
